import React from "react";
import "./DynamicTable.scss";
import InternalLinkData from "./InternalLinkData";
import TextData from "./TextData";
import ExternalLinkData from "./ExternalLinkData";
import RightArrowIcon from '../../../src/assets/Images/rightarrow.svg';
import LeftArrowIcon from '../../../src/assets/Images/leftarrow.svg'


function DynamicTable({ title, columns, data, redirect }) {
    return (
        <div
            className="dynamic-table-container"
            id={`${title.split(" ").join("-")}-table`}
        >
            <h3>{title}</h3>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            {columns?.map((col) => (
                                <th key={`col-title-${col}`}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((row, i) => {
                            return (
                                <tr key={row.name} className="row">
                                    {row.values.map((val) => {
                                        return val.type === "link" ? (
                                            <td>
                                                <InternalLinkData
                                                    value={val.value}
                                                    documentationSection={redirect ? redirect : title}
                                                />
                                            </td>
                                        ) : val.type === "external" ? (
                                            <td>
                                                <ExternalLinkData value={val.value} href={val.href} />
                                            </td>
                                        ) : val.type === "image" ? (
                                            <td className="arrow-container">
                                                <span className="arrow-icon">
                                                    <img src={LeftArrowIcon} alt="Left Arrow" />
                                                </span>
                                                <TextData value={val.value} />
                                                <span className="arrow-icon">
                                                    <img src={RightArrowIcon} alt="Right Arrow" />
                                                </span>
                                            </td>
                                        ) : (
                                            <td className={val.type === "multiline" ? "multiline-cell" : ""}>
                                                <TextData value={val.value} />
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default DynamicTable;
